import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "appmain" }
const _hoisted_2 = {
  key: 0,
  class: "appmain"
}

import { useRouter, useRoute } from "vue-router";
import { ref, onMounted ,watch} from "vue";
 

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;

const mb = ref('');

const router = useRouter();
const route = useRoute();

const key = ref('');

 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);

onMounted(() => {
  key.value = route.path;
  mb.value =props.isMobile; 
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (key.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "fade-transform",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_router_view, {
                key: key.value,
                isMobile: mb.value
              }, null, 8, ["isMobile"]))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})